const PRESIGN_URL = 'https://np6jnttflc6q6l7tltptsd2u4a0cdhmi.lambda-url.us-east-1.on.aws/';

export const uploadFile = async (file: File) => {
    const response = await fetch(PRESIGN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileName: file.name }),
    });

    if (!response.ok) {
        throw new Error('Failed to get upload URL');
    }

    const { uploadUrl } = await response.json();

    const uploadResponse = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
    });

    if (!uploadResponse.ok) {
        throw new Error('Failed to upload file');
    }

    return uploadResponse;
};
